// extracted by mini-css-extract-plugin
export default {"wrapper":"Image_wrapper__eMQeC","hidden":"Image_hidden__O2WeQ","visible":"Image_visible__Ym9Nh"};